import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import ChartWrapper from 'components/Apps/EnvironmentMonitor/ChartWrapper'
import ListWrapper from 'components/Apps/EnvironmentMonitor/ListView'
import { SaturationWhite } from 'helpers/customIcons'
import {
  CHART_TYPE_FORECAST,
  CHART_TYPE_HISTORICAL,
  TYPE_SATURATION,
} from 'helpers/environmentMonitor'
import {
  fetchHistoricalData,
  fetchForecastData,
  setListForecastData,
} from 'reducers/environmentMonitor/reducer'
import ChartStv from 'components/Apps/EnvironmentMonitor/Charts/ChartStv'
import ChartHistorical from 'components/Apps/EnvironmentMonitor/Charts/ChartHistorical'

class Saturation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartType: CHART_TYPE_FORECAST,
      datasetIndex: 1,
    }
  }

  componentList = {
    [`${CHART_TYPE_FORECAST}`]: ChartStv,
    [`${CHART_TYPE_HISTORICAL}`]: ChartHistorical,
  }

  componentDidMount() {
    this.fetchChartData(this.props.activeSite, this.state.chartType)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.activeSite !== nextProps.activeSite ||
      this.state.chartType !== nextState.chartType
    ) {
      this.fetchChartData(nextProps.activeSite, nextState.chartType)

      return false
    }

    return true
  }

  onChartTypeBtnClick = evt => {
    this.setState({
      chartType: evt.currentTarget.value,
    })
  }

  fetchChartData = (activeSite, chartType) => {
    const { fetchForecastData, fetchHistoricalData } = this.props
    const payload = {
      site: activeSite,
      now: moment.utc().format('YYYY-MM-DD HH:00:00'),
      type: TYPE_SATURATION,
    }

    if (chartType === CHART_TYPE_FORECAST) {
      payload.depth = 5
      fetchForecastData(payload)
    } else {
      fetchHistoricalData(payload)
    }
  }

  render() {
    const { chartData } = this.props
    const { chartType, datasetIndex } = this.state
    const ChartView = this.componentList[chartType]

    return (
      <>
        <ChartWrapper
          loader={chartData.get('loader')}
          chartType={chartType}
          chartTypeChange={this.onChartTypeBtnClick}>
          <ChartView
            unit="%"
            chartData={chartData}
            datasetIndex={datasetIndex}
          />
        </ChartWrapper>
        <ListWrapper
          unit="%"
          icon={SaturationWhite}
          chartType={chartType}
          dataView={chartData.get('dataView')}
        />
      </>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    chartData: state.getIn(['environmentMonitor', 'chartData']),
  }),
  {
    fetchHistoricalData,
    fetchForecastData,
    setListForecastData,
  },
)(Saturation)
